import DomPurify from "isomorphic-dompurify";

import { Button } from "@jti/core-components/components/Button";

import styles from "./PointsBlock.module.scss";

const { sanitize } = DomPurify;

type PointsBlockProps = {
  hasLogo?: boolean;
  knowMoreUrl?: string;
  urlText?: string;
  points?: number;
  pointsLabel: string;
  text: string;
  title?: string;
};

export const PointsBlock: React.FC<PointsBlockProps> = ({ knowMoreUrl, urlText, points, pointsLabel, text, title }) => {
  return (
    <div className={styles.wrapper}>
      {title && (
        <div className={styles.title}>
          <p>{title}</p>
        </div>
      )}
      <div className={styles.section}>
        {points && (
          <div className={styles.pointsWrapper}>
            <p className={styles.points} data-testid="cart-subtotal-points">
              {points}
            </p>
            <p className={styles.pointsText}>{pointsLabel}</p>
          </div>
        )}
        <div className={styles.text}>
          <span className={styles.collectText}>
            <span dangerouslySetInnerHTML={{ __html: sanitize(text) }}></span>
          </span>
          {knowMoreUrl && (
            <Button variant="text" size="sm" href={knowMoreUrl}>
              {urlText}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};
